import React from 'react';

import { CircularProgress, CircularProgressProps } from '@mui/material';

type Props = CircularProgressProps;

const Loading: React.FC<Props> = ({ id, ...props }) => <CircularProgress id={id} {...props} />;

export default Loading;
